import React from 'react'

import { withRouter, Link } from 'react-router-dom'

import { Container, Icon, Message, Tab } from 'semantic-ui-react';

import {
  PaneInformations,
  PaneActivity,
  PaneContacts,
  PaneDocuments,
  PaneLogbook,
  PaneSensors
} from './panes';

import { BreadcrumbHelper, Typeof } from 'utils';

import './style.css';

class DeviceScene extends React.Component {

  constructor(props) {
    super(props);

    this.navigateTo = this.navigateTo.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);

    this.handleModelChange = this.handleModelChange.bind(this);
    this.handleDissociate = this.handleDissociate.bind(this);

    this.handleConfigurationSave = this.handleConfigurationSave.bind(this);

    let panes = [];

    //Pane informations
    panes.push({
      menuItem: {
        content: 'Informations',
        icon: 'info'
      },
      render: () => {
        const { device } = this.state;

        return <PaneInformations device={device} appStoreVersion={this.props.appStoreVersion} onModelChange={this.handleModelChange} onDissociate={this.handleDissociate} />
      }
    });

    //Pane sensors
    panes.push({
      menuItem: {
        content: 'Capteurs',
        icon: 'microchip'
      },
      render: () => {

        const { device } = this.state;
        const { sensors } = this.props;

        return <PaneSensors device={device} sensors={sensors} onConfigurationSave={this.handleConfigurationSave} />
      }
    });

    //Pane documents
    panes.push({
      menuItem: {
        content: 'Documents',
        icon: 'folder open'
      },
      render: () => {

        const { device } = this.state;

        return <PaneDocuments device={device} />
      }
    });

    //Pane logbook
    panes.push({
      menuItem: {
        content: 'Journal de bord',
        icon: 'book'
      },
      render: () => {

        const { device } = this.state;

        return <PaneLogbook device={device} />
      }
    });

    //Pane activity
    panes.push({
      menuItem: {
        content: 'Activité',
        icon: 'feed'
      },
      render: () => {

        const { device } = this.state;

        return <PaneActivity device={device} />
      }
    });

    //Pane contacts
    panes.push({
      menuItem: {
        content: 'Contacts',
        icon: 'address book'
      },
      render: () => {

        const { device } = this.state;

        return <PaneContacts device={device} />
      }
    });

    //Select active tab based on hash
    let hash = window.location.hash.trim().substring(1);
    let activeIndex = hash.length > 0 ? null : 0;

    if (!activeIndex) {

      for(let i = 0; i < panes.length; i++) {

        if(panes[i].id === hash) {
          activeIndex = i;
          break;
        }
      }

      //Unknown hash
      if(!activeIndex) {
        activeIndex = 0;
        window.location.hash = '';
      }
    }

    const { device } = this.props;

    this.state = {
      device: device,
      panes: panes,
      activeIndex: activeIndex
    };

    this.updateBreadcrumb();
  }

  updateBreadcrumb() {

    //Update breadcrumb
    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');

    const { device } = this.props;

    //Add clinic part
    if (Typeof.object(device.clinic)) {
      BreadcrumbHelper.push('Cliniques', '/clinics');
      BreadcrumbHelper.push(device.clinic.name, `/clinics/${device.clinic.id}`);
    }

    BreadcrumbHelper.push(`Valise #${device.id}`);

    //Active pane
    let pane = this.state.panes[this.state.activeIndex];
    BreadcrumbHelper.push(pane.menuItem.content);

    BreadcrumbHelper.flush();
  }

  navigateTo(index) {

    this.setState({ activeIndex: index }, this.updateBreadcrumb);

    //Update location hash
    let pane = this.state.panes[index];
    window.location.hash = pane.id ?? '';
  }

  handleTabChange(e, { activeIndex }) {
    this.navigateTo(activeIndex);
  }

  handleConfigurationSave() {
    this.forceUpdate();
  }

  handleModelChange(update) {

    let device = { ...this.state.device, ...update }

    if (!Typeof.string(update.delivery_date)) {
      delete device.delivery_date;
    }

    if (!Typeof.string(update.subscription_deadline)) {
      delete device.subscription_deadline;
    }

    this.setState({
      device: device
    }, this.updateBreadcrumb);
  }

  handleDissociate() {

    const { device } = this.state;
    delete device.clinic;

    this.setState({
      device: device
    }, this.updateBreadcrumb);
  }

  render() {

    const { panes, activeIndex, device } = this.state;

    let configurationWarning = null;

    if (!Typeof.object(device.current_configuration)) {
      configurationWarning = (
        <span>
          Aucune <Link onClick={() => this.navigateTo(1)}>configuration</Link> de capteur
        </span>
      )
    } else if(!device.current_configuration.is_valid) {
      configurationWarning = (
        <span>
          La <Link onClick={() => this.navigateTo(1)}>configuration</Link> actuelle des capteurs n'est pas valide
        </span>
      );
    }

    return (
      <React.Fragment>

        <Container>

          {/* Configuration warning */}
          {configurationWarning &&
            <Message warning>
              <Icon name='warning sign' />
              {configurationWarning}
            </Message>
          }

          <Tab
            id="tabs"
            panes={panes}
            activeIndex={activeIndex}
            menu={{ secondary: false, pointing: true }}
            onTabChange={this.handleTabChange} />

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(DeviceScene);
